import { isActiveProjectStage } from "../deals/stages";

const PROJECT_STAGE_MULTIPLIERS: Record<string, number> = {
  opportunity: 0.2,
  "estimate-sent": 0.5,
  "in-progress": 0.9,
  "on-hold": 0.3,
  "completed-pending-payment": 1,
  "referral-mining": 1,
};

export type ProjectChartBucket = "won" | "pending" | "lost";

export const getProjectChartBucket = (stage: string): ProjectChartBucket => {
  if (stage === "completed") return "won";
  if (stage === "closed-lost") return "lost";
  return "pending";
};

export const getProjectChartMultiplier = (stage: string): number =>
  PROJECT_STAGE_MULTIPLIERS[stage] ?? 0.25;

export const isProjectChartPending = (stage: string): boolean =>
  isActiveProjectStage(stage);
